import { useAuth } from "../../auth/AuthContext";

export function Header() {
  const { user, logout } = useAuth();

  return (
    <header
      className="flex items-center justify-between px-4 py-3"
      style={{ background: "var(--color-primary)", color: "var(--color-white)" }}
    >
      <img src="/assets/logo-white.svg" alt="LOWI" height={20} />
      {user && (
        <div className="flex items-center gap-2">
          <span className="body-small">{user.name || user.email}</span>
          <button className="btn-link body-small" onClick={logout}>
            Sign out
          </button>
        </div>
      )}
    </header>
  );
}
